import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import heroFullStack from "../../assets/HeroSlider/HeroSection_Slider2.png";
import heroCloud from "../../assets/HeroSlider/HeroSection_Slider3.png";
import heroOther from "../../assets/HeroSlider/HeroSection_Slider4.png";
import ghRaisoniLogo from "../../assets/colleges/gh-raisoni-logo.png";
import yeshwantraoLogo from "../../assets/colleges/yeshwantrao-chavan-logo.png";
import jdCollegeLogo from "../../assets/colleges/jd-college-logo.png";
import ramdeobabaLogo from "../../assets/colleges/ramdeobaba-university-logo.png";
import "./Hero.css";

const SLIDES = [
  {
    id: 2,
    image: heroFullStack,
    alt: "Full-stack development project",
  },
  {
    id: 3,
    image: heroCloud,
    alt: "Cloud technology project",
  },
  {
    id: 4,
    image: heroOther,
    alt: "Professional technology project",
  },
];

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const changeSlide = (direction) => {
    setCurrentSlide((previousSlide) => {
      if (direction === "prev") {
        return (previousSlide - 1 + SLIDES.length) % SLIDES.length;
      }

      if (direction === "next") {
        return (previousSlide + 1) % SLIDES.length;
      }

      if (typeof direction === "number") {
        return direction;
      }

      return previousSlide;
    });
  };

  const activeSlide = SLIDES[currentSlide];

  return (
    <section className="hero2 hero2-full-slider">
      {/* Active slider image */}
      <div className="hero2-full-slider-background">
        <img
          key={activeSlide.id}
          src={activeSlide.image}
          alt={activeSlide.alt}
          className="hero2-full-slider-image"
        />
      </div>

      {/* Image overlay */}
      <div className="hero2-full-slider-overlay" />

      {/* Hero content */}
      <div className="hero2-content-wrapper hero2-full-slider-content">
        <div className="hero2-left-content">
          <h1>
            Learn in-demand skills,
            <br />
            work on <span>live IT projects</span>,
            <br />
            and accelerate your tech career
            <br />
            with <span>WeIntern</span>
          </h1>

          <p>
            Learn in-demand skills, work on live IT projects, and accelerate your tech career with WeIntern — the talent powerhouse driving Wenexa.
          </p>

          <div className="hero2-buttons">
            <Link
              to="/internship"
              className="hero2-primary-button"
            >
              Explore Live Projects <span>→</span>
            </Link>

            <a
              href="#courses"
              className="hero2-secondary-button"
            >
              View Courses
            </a>
          </div>

          <div className="hero2-trust-section">
            <div className="hero2-college-logos">
              <img src={ghRaisoniLogo} alt="GH Raisoni College" className="hero2-college-logo-img" />
              <img src={yeshwantraoLogo} alt="Yeshwantrao Chavan College" className="hero2-college-logo-img" />
              <img src={jdCollegeLogo} alt="JD College of Engineering" className="hero2-college-logo-img" />
              <img src={ramdeobabaLogo} alt="Ramdeobaba University" className="hero2-college-logo-img" />
            </div>

            <div className="hero2-trust-text">
              <strong>Trusted by 50+ Colleges</strong>
              <span>Students from top institutions choose us</span>
            </div>
          </div>
        </div>
      </div>

      {/* Slider controls */}
      <div className="hero2-slider-controls hero2-full-slider-controls">
        <button
          type="button"
          className="hero2-slider-arrow"
          onClick={() => changeSlide("prev")}
          aria-label="Previous slide"
        >
          <Icon icon="mdi:chevron-left" />
        </button>

        <div className="hero2-slider-dots">
          {SLIDES.map((slide, index) => (
            <button
              key={slide.id}
              type="button"
              className={`hero2-dot ${
                currentSlide === index ? "hero2-dot-active" : ""
              }`}
              onClick={() => changeSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
              aria-current={currentSlide === index ? "true" : undefined}
            />
          ))}
        </div>

        <button
          type="button"
          className="hero2-slider-arrow"
          onClick={() => changeSlide("next")}
          aria-label="Next slide"
        >
          <Icon icon="mdi:chevron-right" />
        </button>
      </div>
    </section>
  );
};

export default Hero;